enum UTIL_ACTION_TYPES {
  CHECK_HASH = 'CHECK_HASH',
  NEW_VERSION_AVILABLE = 'NEW_VERSION_AVILABLE',
  UPDATE_OLD_LOCATION = 'UPDATE_OLD_LOCATION',
  TRIGGER_JITSI_EMAIL = 'TRIGGER_JITSI_EMAIL',
  REFRESH_INTERNAL_DATA = 'REFRESH_INTERNAL_DATA',
  FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS',
  SAVE_NOTIFICATIONS = 'SAVE_NOTIFICATIONS',
  SUBSCRIBE_NOTIFICATIONS = 'SUBSCRIBE_NOTIFICATIONS',
  UNSUBSCRIBE_NOTIFICATIONS = 'UNSUBSCRIBE_NOTIFICATIONS',
  READ_NOTIFICATIONS = 'READ_NOTIFICATIONS',
  ENABLE_DISABLE_NOTIFICATIONS = 'ENABLE_DISABLE_NOTIFICATIONS',
  UPDATE_IS_READ_NOTIFICATION = 'UPDATE_IS_READ_NOTIFICATION',
  UPDATE_UNREAD_AND_TOTAL_COUNT = 'UPDATE_UNREAD_AND_TOTAL_COUNT',
  IS_ON_NOTIFICATION_FLOW = 'IS_ON_NOTIFICATION_FLOW',
}

export default UTIL_ACTION_TYPES;
